import { render, staticRenderFns } from "./Contents.vue?vue&type=template&id=501a82f7"
import script from "./Contents.vue?vue&type=script&lang=js"
export * from "./Contents.vue?vue&type=script&lang=js"
import style0 from "./Contents.vue?vue&type=style&index=0&id=501a82f7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports